import { useState } from "react";
import axios from "../utils/axios";

function usePutRequest() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const onPutRequest = async (url, body) => {
    setLoading(true);
    try {
      const res = await axios.put(url, body);
      setData(res.data);
      setLoading(false);
    } catch (error) {
      setError(error?.message);
      setLoading(false);
    }
  };

  return { data, loading, error, onPutRequest };
}

export default usePutRequest;
